import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import ModaleDefaut from '@/components/ModaleDefaut/ModaleDefaut';

import styles from '@/modals/ContentModalRenonciation/styles.module.css';

interface ModalRenonciationInitialProps {
  nomProduit: string;
  delayDays: number;
  isPending: boolean;
  isConfirmDisabled?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ModalRenonciationInitial = ({
  nomProduit,
  delayDays,
  isPending,
  isConfirmDisabled = false,
  onConfirm,
  onClose,
}: ModalRenonciationInitialProps) => {
  const { t } = useTranslation();

  const isRetractation = delayDays === 14;
  const prefix = isRetractation ? 'modals.cancelableModal.retractation.' : 'modals.cancelableModal.';

  return (
    <ModaleDefaut
      title={t(`${prefix}title`, { nomContrat: nomProduit })}
      content={
        <div className={styles.initialContent}>
          <div className={styles.textBlock}>
            <p className={styles.text}>{t(`${prefix}text1`)}</p>
            <p className={styles.text}>{t('modals.cancelableModal.text2', { delayDays })}</p>
            <p className={styles.text}>{t('modals.cancelableModal.text3')}</p>
          </div>
          <div className={styles.buttonsRow}>
            <MtxButton
              variant="primary"
              size="large"
              fullWidth
              onClick={onConfirm}
              disabled={isPending || isConfirmDisabled}
            >
              <div>{isPending ? t('modals.cancelableModal.pendingText') : t(`${prefix}validateButton`)}</div>
            </MtxButton>
            <MtxButton variant="tertiary" size="large" fullWidth onClick={onClose} disabled={isPending}>
              <div>{t('modals.cancelableModal.cancelButton')}</div>
            </MtxButton>
          </div>
        </div>
      }
      onClickClose={onClose}
      size="large"
      mobileStyle="stick-to-bottom"
    />
  );
};

export default ModalRenonciationInitial;
